import { useTranslation } from 'react-i18next';
import { Button, Card, Cluster, GiftIcon } from '@src/components';
import { ThemeIcon } from '@src/theme/ThemeIcon';

export function FullGameUpgradeCard({ archived, onExpand }: {
  archived: boolean;
  onExpand: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Card
      tone="support"
      icon={<ThemeIcon name="gift" fallback={<GiftIcon />} />}
      title={t('box.organizer.fullGame.title')}
      action={
        <Cluster justify="end" wide>
          <Button variant="primary" size="large" disabled={archived} onClick={onExpand} testId="box-convert">
            {t('box.organizer.fullGame.button')}
          </Button>
        </Cluster>
      }
      testId="box-full-game"
    >
      {t('box.organizer.fullGame.body')}
    </Card>
  );
}
